import { BaseAction } from "../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { clearBookingFlowAtoms } from "../../../Orchestrator/Recoils/clearBookingFlowAtoms";
import { IAddShuttleTransferActionParams } from "../../../Orchestrator/Types/Interface/ActionParams/UpcomingPastBookingActionParams";

class AddShuttleTransferClickAction extends BaseAction<string, IAddShuttleTransferActionParams> {

    override async run(): Promise<string> {
        const { bookingId, tripData } = this.params!

        try {
            // Wipe any flow state left over from a prior aborted checkout
            // (e.g. white-page redirect failure) before seeding this flow's
            // own writes. Otherwise stale shuttles, train selections or
            // payment items bleed into the trip summary.
            clearBookingFlowAtoms();
            updateRecoilState("displayPassengerDataAtom", tripData.passengers);
            updateRecoilState("selectedTripsDataAtom", tripData);
        } catch (error: any) {
            console.error("Error fetching data:", error);
        } finally {
            return bookingId
        }
    }
}

export const addShuttleTransferClickAction = new AddShuttleTransferClickAction()